<template>
    <div class="users">
         <div class="row">
            <div class="col-md-12 text-right">
                <button class="btn btn-primary create-project" @click="showModal('category')"><i class="fa fa-plus"></i> Create Category</button>
                <button class="ml-2 btn btn-primary create-project" @click="showModal('subcategory')"><i class="fa fa-plus"></i> Create Sub Categories</button>

            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                    <b-table :fields="fields" striped hover :items="categories">
                         <template v-slot:head(showid)="">
                             #ID
                        </template>
                        <template v-slot:cell(available)="data">
                            <b-badge :variant="data.item.available==true ? 'success':'danger'">{{data.item.available==true ? 'Available':'Unavailable'}}</b-badge>
                            
                        </template>
                        <template v-slot:cell(subcategories)="data">
                            <div v-for="(item,i) in getSubCategories(data.item.id)" :key="i">
                              <span>{{i+1}} </span> <span>{{ item.name}}</span>   

                            </div>
                            <div v-if="getSubCategories(data.item.id).length<1">No Subcategories exists</div>

                        </template>
                    </b-table>

            </div>
        </div>

        <a-modal
            :title="type=='category' ? ' New Category':'New Sub Category'"
            :visible="visible"
            :footer="null"
            @cancel="visible=false"
            >
            
            <div class="row">
                <div class="col-md-12 col-12">
                    <label for="username"><strong>{{type=='category' ? 'Category Name':'Sub Category Name'}}</strong> </label>
                    <input v-model="new_category.name" type="text" class="form-control" placeholder="">

                </div>
                
            </div>
            <div class="row mt-2">
                <div class="col-md-12 col-12">
                        <label for="email"><strong>Availability</strong>: </label>
                        <select v-model="new_category.available" class="form-control" name="" id="">
                            <option value="true">Available</option>
                            <option value="false">Not Available</option>

                        </select>

                </div>                
            </div>
            <div v-if="type=='subcategory'" class="row mt-2">
                <div class="col-md-12 col-12">
                        <label for="email"><strong>Parent Category</strong>: </label>
                        <select v-model="new_category.categoryid" class="form-control" name="" id="">
                            <option v-for="(item,i) in categories" :key="i" :value="item.id">{{item.name}}</option>

                        </select>

                </div>                
            </div>

           
            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-block" @click="handleCancel">Create</button>
                </div>
            </div>
        </a-modal>

       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: "Users",
    computed:{
        ...mapGetters(['categories','subcategories','autoids'])
    },
    data() {
      return {
          type:'',
          new_category:{
              name:'',
              available:true,
              categoryid:'',
              showid:'0',

          },
          fields:[
              'showid',
              'name',
              'available',
              'subcategories'

          ],
        visible: false,

       
      };
    },

    methods: {
        getSubCategories(id){
           return this.subcategories.filter(item=>item.categoryid==id)

        },
        
      showModal(type) {
        this.type=type
        if(this.type=='subcategory' && this.categories.length>0){
            this.visible = true;

        }
        else if(this.type=='category'){
            this.visible = true;

        }
      },
      clearValues(){
          this.new_category={
              name:'',
              available:true,
              categoryid:''

            }
        this.visible = false;

      },
      handleCancel(e) {
          if(this.new_category.name!=''){
            if(this.type=='category'){
            let obj={...this.new_category}   
            delete obj.categoryid
            obj.showid=this.autoids.categories+1
            this.$store.dispatch("updateAutoId",{categories:this.autoids.categories+1})
        

            this.$store.dispatch("createCategories",obj)
            this.clearValues()

            }
            else{
                if(this.new_category.categoryid!=''){
                    
                    this.$store.dispatch("createSubCategories",this.new_category)
                    this.clearValues()

                }
                else{
                    this.$store.commit("setNotifications",{message:'Select A Parent Category',type:'error'})

                }
            
            }  
            

          }
          else{
            this.$store.commit("setNotifications",{message:'Write category name before saving',type:'error'})

          }
      },
    
    }
}
</script>
